import React from 'react';
import styled from 'styled-components';
import { TWO_COLUMN_MAX_WIDTH } from '../Grid';
import { useVideoPlayer } from './hooks/useVideoPlayer';
import { S4XMuxVideo } from './S4XMuxVideo/S4XMuxVideo';
const Container = styled.div `
  display: flex;
  position: absolute;
  height: 100%;
  width: 100%;
  overflow: hidden;
  .desktop {
    display: flex;
  }
  .mobile {
    display: none;
  }
  @media (max-width: ${TWO_COLUMN_MAX_WIDTH}) {
    .mobile {
      display: ${({ hasMobile }) => (hasMobile ? 'flex' : 'none')};
    }
    .desktop {
      display: ${({ hasMobile }) => (hasMobile ? 'none' : 'flex')};
      // if no mobile video was passed in
      // shift the zoomed in dekstop video to focus on the right side
      mux-video {
        ::part(video) {
          --media-object-position: ${({ hasMobile }) => hasMobile ? '50% 50%' : '85%'};
        }
      }
    }
  }

  mux-video {
    position: absolute;
    display: flex;
    height: 100%;
    width: 100%;
    ::part(video) {
      --media-object-fit: cover;
    }
  }
  :after {
    content: ' ';
    position: absolute;
    background: black;
    opacity: 30%;
    height: 100%;
    width: 100%;
  }
`;
export const BackgroundVideo = ({ desktopVideo, mobileVideo, isPlaying, }) => {
    var _a, _b;
    const autoplay = true;
    const { loop, isMuted } = useVideoPlayer({
        autoplay,
        includeSound: false,
    });
    if (!desktopVideo.muxData) {
        return null;
    }
    return (React.createElement(Container, { hasMobile: ((_a = mobileVideo === null || mobileVideo === void 0 ? void 0 : mobileVideo.muxData) === null || _a === void 0 ? void 0 : _a.playbackId) !== undefined },
        React.createElement("div", { className: "desktop" },
            React.createElement(S4XMuxVideo, { muxPlaybackId: desktopVideo.muxData.playbackId, "metadata-video-title": desktopVideo.title, "alt-text": desktopVideo.altText, loop: loop, autoPlay: autoplay, muted: isMuted, playing: isPlaying })),
        mobileVideo && (React.createElement("div", { className: "mobile" },
            React.createElement(S4XMuxVideo, { muxPlaybackId: ((_b = mobileVideo.muxData) === null || _b === void 0 ? void 0 : _b.playbackId) || '', "metadata-video-title": mobileVideo.title, "alt-text": mobileVideo.altText, loop: loop, autoPlay: autoplay, muted: isMuted, playing: isPlaying })))));
};
//# sourceMappingURL=BackgroundVideo.js.map